import React from "react";
import { DashboardLayoutContainer } from "./Layout.style";

export const DashboardLayout: React.FC<{ dark?: boolean; children: any }> = ({
  dark,
  children,
}) => (
  <DashboardLayoutContainer notMain={dark}>{children}</DashboardLayoutContainer>
);
